import React, { useEffect, useState } from 'react';

import "../../../css/components/OrderInfo/EditOrderModal/EditOrderModal.css";

import { Message } from '../../../utils/Message';
import { delay } from '../../../utils';
import { EditOptionModalList } from '../../../constants';

import { updateAddressOption } from '../../../service/api/AddressOptions/apiDeliver';

const EditOptionModal = ({ option, onClose, setOptionData }) => {
  // if (!order) return null;

  const [form, setForm] = useState({
    id: option?.id,
    district: option?.district,
    city: option?.city,
    deliveryWeek: option?.deliveryWeek,
    description: option?.description,
    available: option?.available,
  });

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setForm(prev => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log(form)
    const response = await updateAddressOption(form);
    console.log(response.data);
    if (response.status === 200) {
      Message('紀錄更新成功');
      await delay(1);
      onClose(null);
      setOptionData(prev => prev.map(o => o.id === form.id ? response.data.result : o));
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <div className="custom-modal-backdrop">
        <div className="custom-modal">
          <div className="custom-modal-header">
            <h5 className="modal-title">編輯區域</h5>
            <button className="btn-close" onClick={(e) => { onClose(null); e.preventDefault(); }}></button>
          </div>

          <div className="custom-modal-body">

            {/* 基本資訊 */}
            {EditOptionModalList.map(field => (
              <div className="input-group mb-3" key={field.value}>
                <span className="input-group-text">
                  {field.label}
                  {field.required && <span className="required-star">*</span>}
                </span>
                <input
                  type={field.type}
                  className="form-control"
                  name={field.value}
                  value={form?.[field.value]}
                  onChange={handleChange}
                  placeholder={field.placeholder || ""}
                  required={field.required}
                  pattern={field.pattern}
                  title={field.title}
                  max={field.max}
                  min={field.min}
                />
              </div>
            ))}

            {/* 使用狀態 */}
            <div className="input-group mb-3">
              <span className="input-group-text">使用狀態</span>
              <select
                className="form-select"
                value={form.available}
                onChange={e => setForm(prev => ({ ...prev, available: Number(e.target.value) }))}
                required
              >
                <option value="1">停用</option>
                <option value="0">啟用</option>
              </select>
            </div>
          </div>

          <div className="custom-modal-footer">
            <button className="btn btn-secondary" onClick={(e) => { onClose(null); e.preventDefault(); }}>取消</button>
            <button className="btn btn-gradient-primary" type="submit">儲存</button>
          </div>
        </div>
      </div>
    </form>
  );
};

export { EditOptionModal };
